<!-- prettier-ignore -->
<nav class="breadcrumb" aria-label="breadcrumb">
  @for (title of titles; track $index; let last = $last) {
    @if (title.url && !last) {
      <a [routerLink]="title.url" class="breadcrumb-link">
        {{ title.label }}
      </a>
    } @else {
      <span class="breadcrumb-current" [attr.aria-current]="last ? 'page' : null" >
        {{ title.label }}
      </span>
    }

    @if (!last) {
      <span class="breadcrumb-sep">></span>
    }
  }
</nav>
